const STORAGE_KEY = "pp_sensitive_action_verified_at";
const WINDOW_MS = 10 * 60 * 1000;

export function markSensitiveActionVerified() {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {}
}

export function hasRecentSensitiveActionVerification() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;

    const ts = Number(raw);
    if (!ts) return false;

    return Date.now() - ts < WINDOW_MS;
  } catch {
    return false;
  }
}

export function clearSensitiveActionVerification() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
}